import { render, staticRenderFns } from "./ActiveFiltersPanel.vue?vue&type=template&id=585479d5&"
import script from "./ActiveFiltersPanel.vue?vue&type=script&lang=js&"
export * from "./ActiveFiltersPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports